import './styles.css';
import netsLogo from './nets-logo';

export default angular
  .module('app.logo', [])
  .component('netsLogo', netsLogo);
